import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServiceCenterRoutingModule } from './service-center-routing.module';
import { SharedModule } from '@shared';
import { TasksModule } from '../tasks/tasks.module';
import { AssignedServiceCentersComponent } from './assigned-service-centers/assigned-service-centers.component';
import { SearchServiceCentersComponent, ServiceCenterDetailsDialog } from './search-service-centers/search-service-centers.component';
import { ServiceCenterComplaintsComponent } from './service-center-complaints/service-center-complaints.component';
import { ServiceCenterTasksComponent } from './service-center-tasks/service-center-tasks.component';
import { ApplicantModule } from '../applicant/applicant.module';
import { ComplaintModule } from '../complaint/complaint.module';
import { ComplianceModule } from '../compliance/compliance.module';
import { NotesModule } from '../notes/notes.module';
import { PaymentsModule } from '../payments/paymentsmodule';
import { SiteInspectionModule } from '../site-inspection/site-inspection.module';
import { LicenseChecklistModule } from '../license-checklist/license-checklist.module';
import { PrintServiceCenterComponent } from './print-service-centers/print-service-centers.component';
import { ManagerNotesModule } from '../manager-notes/manager-notes.module';
import { ReportedEventModule } from '../reported-event/reported-event.module';
import { AssociatedWorkerPermitsModule } from '../associated-worker-permits/associated-worker-permits.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { AddOutOfStateTrainingModalComponent } from './add-out-of-state-training-modal/add-out-of-state-training-modal.component';
import { AddOregonTrainingModalComponent } from './add-oregon-training-modal/add-oregon-training-modal.component';
import { AuditLoggingModule } from '../audit-log/audit-log.module';
import { ServiceCenterSnapshotDialog } from './search-service-centers/search-service-centers.component';

@NgModule({
  declarations: [
    AssignedServiceCentersComponent,
    SearchServiceCentersComponent,
    ServiceCenterComplaintsComponent,
    ServiceCenterTasksComponent,
    PrintServiceCenterComponent,
    ServiceCenterDetailsDialog,
    AddOregonTrainingModalComponent,
    AddOutOfStateTrainingModalComponent,
    ServiceCenterSnapshotDialog
  ],
  imports: [
    CommonModule,
    SharedModule,
    ServiceCenterRoutingModule,
    PaymentsModule,
    NotesModule,
    ApplicantModule,
    ComplianceModule,
    ComplaintModule,
    SiteInspectionModule,
    LicenseChecklistModule,
    ManagerNotesModule,
    ReportedEventModule,
    AssociatedWorkerPermitsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    AuditLoggingModule,
    TasksModule
  ]
})
export class ServiceCenterModule { }
